import $ from 'jquery';

import { BrowserStorageKeys } from '../../../Common/Constants/QueryString_Keys.Constant';
import { EventGroupType } from '../../../Common/Constants/EventGroupType.Constants';
import { SupportTopic } from '../Models/SupportTopic';
import { AppSessionContext } from '../../../Services/Services.Primary/SessionContext/AppSessionContext';
import TelemetryService from '../../../Services/Services.Primary/Telemetry/TelemetryService';
import { QueryStringParserService } from '../../../Services/Services.Secondary';
import BrowserStorage from '../../../Services/Services.Secondary/BrowserStorage';
import LocalizationService from '../../../Services/Services.Secondary/Localization/LocalizationService';
import { BrowserStorageType } from '../../../Services/Services.Secondary/Models/BrowserStorageTypeEnum';
import { DeepLinkInfo } from '../../Workspace/Create/Models/DeepLinkInfo';
import { Constants } from '../Constants';
import { BrowserInfo } from '../Models/BrowserInfo';
import { SupportPanelState } from '../Models/SupportPanelState';

let Constant = Constants.getInstance();
let sessionContext = AppSessionContext.getInstance();
var resx = LocalizationService.getInstance();

let MinuteAgoText = resx.getLocalizedResource('MinuteAgo_text');
let MinutesAgoText = resx.getLocalizedResource('MinutesAgo_text');
let HourAgoText = resx.getLocalizedResource('HourAgo_text');
let HoursAgoText = resx.getLocalizedResource('HoursAgo_text');
let DayAgoText = resx.getLocalizedResource('DayAgo_text');
let DaysAgoText = resx.getLocalizedResource('DaysAgo_text');

let AllPrograms = resx.getLocalizedResource('AllPrograms');
let GeneralProgram = resx.getLocalizedResource('GeneralProgram');
let CspProgram = resx.getLocalizedResource('CspProgram');
let MpnProgram = resx.getLocalizedResource('MpnProgram');
let IncentivesProgram = resx.getLocalizedResource('IncentivesProgram');
let ReferralsProgram = resx.getLocalizedResource('ReferralsProgram');
let SamProgram = resx.getLocalizedResource('SamProgram');
let OemProgram = resx.getLocalizedResource('OemProgram');
let OtherProgram = resx.getLocalizedResource('OtherProgram');
let IsvProgram = resx.getLocalizedResource('IsvProgram');
let DeveloperToolsProgram = resx.getLocalizedResource('DeveloperToolsProgram');
let MicrosoftDynamicsProgram = resx.getLocalizedResource('MicrosoftDynamicsProgram');
let ProductSupportProgram = resx.getLocalizedResource('ProductSupportProgram');
let VolumeLicensingProgram = resx.getLocalizedResource('VolumeLicensingProgram');
let FullRegexErrorMessage_text = resx.getLocalizedResource('FullRegexErrorMessage_text');
let XssRegexErrorMessage_text = resx.getLocalizedResource('XssRegexErrorMessage_text');

/** Localized String */
let HelpAndSupport = resx.getLocalizedResource('HelpSupport_text');
let Benefits = resx.getLocalizedResource('BenefitsWorkspace');
let Billing = resx.getLocalizedResource('BillingWorkspace');
let Collaborate = resx.getLocalizedResource('CollaborateWorkspace');
let Customers = resx.getLocalizedResource('CustomersWorkspace');
let Insights = resx.getLocalizedResource('InsightsWorkspace');
let Membership = resx.getLocalizedResource('MembershipWorkspace');
let MarketplaceOffers = resx.getLocalizedResource('MarketplaceOffersWorkspace');
let Referrals = resx.getLocalizedResource('ReferralsWorkspace');
let Earnings = resx.getLocalizedResource('EarningsWorkspace');
let Pricing = resx.getLocalizedResource('PricingWorkspace');
let ActionCenter = resx.getLocalizedResource('ActionCenterWorkspace');
let AppsAndGames = resx.getLocalizedResource('AppsAndGamesWorkspace');
let Claims = resx.getLocalizedResource('ClaimsWorkspace');
let CustomerResearch = resx.getLocalizedResource('CustomerResearchWorkspace');
let Edge = resx.getLocalizedResource('EdgeWorkspace');
let Hardware = resx.getLocalizedResource('HardwareWorkspace');
let Incentives = resx.getLocalizedResource('IncentivesWorkspace');
let Quotes = resx.getLocalizedResource('QuotesWorkspace');
let QuotesHelp = resx.getLocalizedResource('QuotesHelpWorkspace');
let AccountSettings = resx.getLocalizedResource('AccountSettingsWorkspace');
let ApiAndIntegrationSupport = resx.getLocalizedResource('ApiAndIntegrationSupportWorkspace');
let Enrollment = resx.getLocalizedResource('EnrollmentWorkspace');
let DeveloperTools = resx.getLocalizedResource('DeveloperToolsWorkspace');
let MicrosoftDynamics = resx.getLocalizedResource('MicrosoftDynamicsWorkspace');
let ProductSupport = resx.getLocalizedResource('ProductSupportWorkspace');
let VolumeLicensing = resx.getLocalizedResource('VolumeLicensingWorkspace');
let AccountPlans = resx.getLocalizedResource('AccountPlansWorkspace');
let Accounts = resx.getLocalizedResource('AccountsWorkspace');
let Contacts = resx.getLocalizedResource('ContactsWorkspace');
let Engagements = resx.getLocalizedResource('EngagementsWorkspace');
let Leads = resx.getLocalizedResource('LeadsWorkspace');
let Opportunities = resx.getLocalizedResource('OpportunitiesWorkspace');
let Partners = resx.getLocalizedResource('PartnersWorkspace');
let UserProvisioning = resx.getLocalizedResource('UserProvisioningWorkspace');
let Calc = resx.getLocalizedResource('CalcWorkspace');
let Compensation = resx.getLocalizedResource('CompensationWorkspace');
let DealAssistance = resx.getLocalizedResource('DealAssistanceWorkspace');
let Proposals = resx.getLocalizedResource('ProposalsWorkspace');
let SalesAccelerator = resx.getLocalizedResource('SalesAcceleratorWorkspace');
let Security = resx.getLocalizedResource('SecurityWorkspace');

let HelpAndSupportProblemTypes = resx.getLocalizedResource('HelpSupport_textPT');
let BenefitsProblemTypes = resx.getLocalizedResource('BenefitsWorkspacePT');
let BillingProblemTypes = resx.getLocalizedResource('BillingWorkspacePT');
let CollaborateProblemTypes = resx.getLocalizedResource('CollaborateWorkspacePT');
let CustomersProblemTypes = resx.getLocalizedResource('CustomersWorkspacePT');
let InsightsProblemTypes = resx.getLocalizedResource('InsightsWorkspacePT');
let MembershipProblemTypes = resx.getLocalizedResource('MembershipWorkspacePT');
let MarketplaceOffersProblemTypes = resx.getLocalizedResource('MarketplaceOffersWorkspacePT');
let ReferralsProblemTypes = resx.getLocalizedResource('ReferralsWorkspacePT');
let EarningsProblemTypes = resx.getLocalizedResource('EarningsWorkspacePT');
let PricingProblemTypes = resx.getLocalizedResource('PricingWorkspacePT');
let ActionCenterProblemTypes = resx.getLocalizedResource('ActionCenterWorkspacePT');
let AppsAndGamesProblemTypes = resx.getLocalizedResource('AppsAndGamesWorkspacePT');
let EdgeProblemTypes = resx.getLocalizedResource('EdgeWorkspacePT');
let HardwareProblemTypes = resx.getLocalizedResource('HardwareWorkspacePT');
let IncentivesProblemTypes = resx.getLocalizedResource('IncentivesWorkspacePT');
let AccountSettingsProblemTypes = resx.getLocalizedResource('AccountSettingsWorkspacePT');
let ApiAndIntegrationSupportProblemTypes = resx.getLocalizedResource('ApiAndIntegrationSupportWorkspacePT');
let DeveloperToolsProblemTypes = resx.getLocalizedResource('DeveloperToolsWorkspacePT');
let MicrosoftDynamicsProblemTypes = resx.getLocalizedResource('MicrosoftDynamicsWorkspacePT');
let ProductSupportProblemTypes = resx.getLocalizedResource('ProductSupportWorkspacePT');
let VolumeLicensingProblemTypes = resx.getLocalizedResource('VolumeLicensingWorkspacePT');
let EnrollmentProblemTypes = resx.getLocalizedResource('EnrollmentWorkspacePT');
let AllProblemTypes = resx.getLocalizedResource('AllProblemTypes_text');
let AccountPlansProblemTypes = resx.getLocalizedResource('AccountPlansWorkspacePT');
let AccountsProblemTypes = resx.getLocalizedResource('AccountsWorkspacePT');
let ContactsProblemTypes = resx.getLocalizedResource('ContactsWorkspacePT');
let EngagementsProblemTypes = resx.getLocalizedResource('EngagementsWorkspacePT');
let LeadsProblemTypes = resx.getLocalizedResource('LeadsWorkspacePT');
let OpportunitiesProblemTypes = resx.getLocalizedResource('OpportunitiesWorkspacePT');
let PartnersProblemTypes = resx.getLocalizedResource('PartnersWorkspacePT');
let UserProvisioningProblemTypes = resx.getLocalizedResource('UserProvisioningWorkspacePT');
let CalcProblemTypes = resx.getLocalizedResource('CalcWorkspacePT');
let CompensationProblemTypes = resx.getLocalizedResource('CompensationWorkspacePT');
let DealAssistanceProblemTypes = resx.getLocalizedResource('DealAssistanceWorkspacePT');
let ProposalsProblemTypes = resx.getLocalizedResource('ProposalsWorkspacePT');
let SalesAcceleratorProblemTypes = resx.getLocalizedResource('SalesAcceleratorWorkspacePT');

let XssValidationRegex = new RegExp(Constant.getRegex.XssRegex);
let FullXssValidation = new RegExp(Constant.getRegex.FullXssRegex);
export class Helper {
  public static lastNotificationBannerHeight = 0;

  public static isEmptyOrSpaces = (str: string) => {
    if (str === undefined) {
      return true;
    }
    if (str === null) {
      return true;
    }
    if (str === '') {
      return true;
    }
    if (str.match(/^ *$/) !== null) {
      return true;
    }
    return false;
  };
  public static isAlphanumeric = (str: string) => {
    return str.match(/^[a-z0-9]+$/i) !== null;
  };
  public static sleep = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  public static formatFileSize = (size: number) => {
    if (size < 1024) {
      return size + ' bytes';
    } else if (size < 1024 * 1024) {
      return (size / 1024.0).toFixed(0) + ' KB';
    } else if (size < 1024 * 1024 * 1024) {
      return (size / 1024.0 / 1024.0).toFixed(1) + ' MB';
    } else {
      return (size / 1024.0 / 1024.0 / 1024.0).toFixed(1) + ' GB';
    }
  };

  public static IsJsonString(str: any) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  public static GetJwtTokenExpiryTimeInMinutes(token: string) {
    if (this.isEmptyOrSpaces(token)) {
      return -60;
    }
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var payload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    let jsonPayload = JSON.parse(payload);
    let currentTime = new Date();
    let expireInMinutes = (currentTime.getTime() - jsonPayload['exp'] * 1000) / 60000;
    return expireInMinutes;
  }

  public static getDivHeight = (divID: string) => {
    let element = document.getElementById(divID);
    return element != null ? element.clientHeight : 0;
  };

  public static checkForNotificationBannerChanges = () => {
    if (Helper.getDivHeight('onedash-banner-notifications') != Helper.lastNotificationBannerHeight) {
      Helper.adjustContainerHeight();
      Helper.lastNotificationBannerHeight = Helper.getDivHeight('onedash-banner-notifications');
    }
  };

  public static adjustContainerHeight = () => {
    // calculate height of onedash header and onedash alert banner.
    let fdHeaderHeight =
      Helper.getDivHeight('onedash-header-wrapper') +
      Helper.getDivHeight('onedash-banner-notifications') +
      Helper.getDivHeight('partnercenter-breadcrumbs');
    let calcHeight = 'calc(100vh - ' + fdHeaderHeight + 'px)';
    if (
      document.getElementById('getPartnerWithCommercialClaimsRoutes') != null &&
      document.getElementById('getPartnerWithCommercialClaimsRoutes')?.style != null
    ) {
      let element = document.getElementById('getPartnerWithCommercialClaimsRoutes');
      if (element) {
        element.style.height = calcHeight;
      }
    }
    if (document.getElementById('getCreateOnlyRoutes') != null) {
      let element = document.getElementById('getCreateOnlyRoutes');
      if (element) {
        element.style.height = calcHeight;
      }
    }
    if (document.getElementById('getMsUserAdminRoutes') != null) {
      let element = document.getElementById('getMsUserAdminRoutes');
      if (element) {
        element.style.height = calcHeight;
      }
    }
    if (document.getElementById('getInternalSupportRoutes') != null) {
      let element = document.getElementById('getInternalSupportRoutes');
      if (element) {
        element.style.height = calcHeight;
      }
    }
  };

  public static isCosmicTicket = (supportTopic: SupportTopic) => {
    if (supportTopic && supportTopic.metadata && supportTopic.metadata.ticketingSystem) {
      let ticketingSystemArr = supportTopic && supportTopic.metadata && supportTopic.metadata.ticketingSystem;
      let lowerCasesticketingSystemArr = ticketingSystemArr.map(value => {
        return value.toLowerCase();
      });
      return lowerCasesticketingSystemArr.indexOf(Constant.ticketingSystem.cosmic.toLowerCase()) != -1;
    } else {
      return false;
    }
  };

  public static refreshPage = (): boolean => {
    let queryParams = QueryStringParserService.getQueryParameters(window.location.search);
    if (
      queryParams[Constant.QueryStringParams.refreshed] &&
      queryParams[Constant.QueryStringParams.refreshed].toLowerCase() === 'true'
    ) {
      // the page was already refreshed, not refreshing it again to prevent refresh loop
      return false;
    } else {
      // ApplicationInsightsLogger.getInstance().logInfo(SupportTopicsEmptyRefreshPageLoggingMessage);
      let currentUrl = window.location.href;
      if (currentUrl.indexOf('?') != -1) {
        window.location.href = currentUrl + '&' + Constant.QueryStringParams.refreshed + '=true';
      } else {
        window.location.href = currentUrl + '?' + Constant.QueryStringParams.refreshed + '=true';
      }
      return true;
    }
  };

  public static cleanPunctuation = (input: string): string => {
    let punctuation = '/[.,/#!?$%^&*;:{}=-_`~()]/g';
    let cleanPhrase = input.replace(punctuation, '');

    return cleanPhrase;
  };

  public static getProgramTagFromId = (programId: string) => {
    switch (programId) {
      case Constant.ProgramId.AllProgramsId:
        return AllPrograms;
      case Constant.ProgramId.CspProgramId:
        return CspProgram;
      case Constant.ProgramId.GeneralProgramId:
        return GeneralProgram;
      case Constant.ProgramId.IncentivesProgramId:
        return IncentivesProgram;
      case Constant.ProgramId.IsvProgramId:
        return IsvProgram;
      case Constant.ProgramId.MpnProgramId:
        return MpnProgram;
      case Constant.ProgramId.ReferralsProgramId:
        return ReferralsProgram;
      case Constant.ProgramId.SamProgramId:
        return SamProgram;
      case Constant.ProgramId.OemProgramId:
        return OemProgram;
      case Constant.ProgramId.OtherProgram:
        return OtherProgram;
      case Constant.ProgramId.DeveloperToolsProgramId:
        return DeveloperToolsProgram;
      case Constant.ProgramId.MicrosoftDynamicsProgramId:
        return MicrosoftDynamicsProgram;
      case Constant.ProgramId.ProductSupportProgramId:
        return ProductSupportProgram;
      case Constant.ProgramId.VolumeLicensingProgramId:
        return VolumeLicensingProgram;
      case '':
        return GeneralProgram;
      default:
        return '';
    }
  };

  public static getWorkspaceTagFromId = (workspaceId: string) => {
    switch (workspaceId) {
      case Constant.WorkspaceCategoryId.ActionCenterId:
        return ActionCenter;
      case Constant.WorkspaceId.AppsAndGamesId:
        return AppsAndGames;
      case Constant.WorkspaceId.BenefitsId:
        return Benefits;
      case Constant.WorkspaceId.BillingId:
        return Billing;
      case Constant.WorkspaceId.ClaimsId:
        return Claims;
      case Constant.WorkspaceId.CollaborateId:
        return Collaborate;
      case Constant.WorkspaceId.CustomersId:
        return Customers;
      case Constant.WorkspaceId.CustomerResearchId:
        return CustomerResearch;
      case Constant.WorkspaceId.EdgeId:
        return Edge;
      case Constant.WorkspaceId.HardwareId:
        return Hardware;
      case Constant.WorkspaceId.IncentivesId:
        return Incentives;
      case Constant.WorkspaceId.InsightsId:
        return Insights;
      case Constant.WorkspaceId.MembershipId:
        return Membership;
      case Constant.WorkspaceId.MarketplaceOffersId:
        return MarketplaceOffers;
      case Constant.WorkspaceId.ReferralsId:
        return Referrals;
      case Constant.WorkspaceId.EarningsId:
        return Earnings;
      case Constant.WorkspaceId.PricingId:
        return Pricing;
      case Constant.WorkspaceId.QuotesId:
        return Quotes;
      case Constant.WorkspaceId.QuotesHelpId:
        return QuotesHelp;
      case Constant.WorkspaceId.HelpAndSupportId:
        return HelpAndSupport;
      case Constant.WorkspaceId.SecurityId:
        return Security;
      case Constant.WorkspaceCategoryId.AccountSettingsId:
        return AccountSettings;
      case Constant.WorkspaceCategoryId.ApiAndIntegrationSupportId:
      case Constant.WorkspaceCategoryId.ApiAndIntegrationSupportOldId:
        return ApiAndIntegrationSupport;
      case Constant.WorkspaceCategoryId.EnrollmentId:
      case Constant.WorkspaceCategoryId.EnrollmentOldId:
        return Enrollment;
      case Constant.WorkspaceCategoryId.DeveloperTools:
        return DeveloperTools;
      case Constant.WorkspaceCategoryId.MicrosoftDynamics:
        return MicrosoftDynamics;
      case Constant.WorkspaceCategoryId.ProductSupport:
        return ProductSupport;
      case Constant.WorkspaceCategoryId.VolumeLicensing:
        return VolumeLicensing;
      case Constant.WorkspaceId.AccountPlans:
        return AccountPlans;
      case Constant.WorkspaceId.Accounts:
        return Accounts;
      case Constant.WorkspaceId.Contacts:
        return Contacts;
      case Constant.WorkspaceId.Engagements:
        return Engagements;
      case Constant.WorkspaceId.Leads:
        return Leads;
      case Constant.WorkspaceId.Opportunities:
        return Opportunities;
      case Constant.WorkspaceId.Partners:
        return Partners;
      case Constant.WorkspaceId.UserProvisioning:
        return UserProvisioning;
      case Constant.WorkspaceId.CALC:
        return Calc;
      case Constant.WorkspaceId.Compensation:
        return Compensation;
      case Constant.WorkspaceId.DealAssistance:
        return DealAssistance;
      case Constant.WorkspaceId.Proposals:
        return Proposals;
      case Constant.WorkspaceId.SalesAccelerator:
        return SalesAccelerator;
      default:
        return '';
    }
  };

  public static getTagFromId = (id: string, isWorkspaceId: boolean) => {
    return isWorkspaceId ? Helper.getWorkspaceTagFromId(id) : Helper.getProgramTagFromId(id);
  };

  public static getProblemTypeHeaderFromId = (id: string, isWorkspaceId: boolean) => {
    return isWorkspaceId ? Helper.getWorkspaceProblemTypeHeaderFromId(id) : AllProblemTypes;
  };

  public static getWorkspaceProblemTypeHeaderFromId = (workspaceId: string) => {
    switch (workspaceId) {
      case Constant.WorkspaceCategoryId.ActionCenterId:
        return ActionCenterProblemTypes;
      case Constant.WorkspaceId.AppsAndGamesId:
        return AppsAndGamesProblemTypes;
      case Constant.WorkspaceId.BenefitsId:
        return BenefitsProblemTypes;
      case Constant.WorkspaceId.BillingId:
        return BillingProblemTypes;
      case Constant.WorkspaceId.CollaborateId:
        return CollaborateProblemTypes;
      case Constant.WorkspaceId.CustomersId:
        return CustomersProblemTypes;
      case Constant.WorkspaceId.EdgeId:
        return EdgeProblemTypes;
      case Constant.WorkspaceId.HardwareId:
        return HardwareProblemTypes;
      case Constant.WorkspaceId.IncentivesId:
        return IncentivesProblemTypes;
      case Constant.WorkspaceId.InsightsId:
        return InsightsProblemTypes;
      case Constant.WorkspaceId.MembershipId:
        return MembershipProblemTypes;
      case Constant.WorkspaceId.MarketplaceOffersId:
        return MarketplaceOffersProblemTypes;
      case Constant.WorkspaceId.ReferralsId:
        return ReferralsProblemTypes;
      case Constant.WorkspaceId.EarningsId:
        return EarningsProblemTypes;
      case Constant.WorkspaceId.PricingId:
        return PricingProblemTypes;
      case Constant.WorkspaceId.HelpAndSupportId:
        return HelpAndSupportProblemTypes;
      case Constant.WorkspaceCategoryId.AccountSettingsId:
        return AccountSettingsProblemTypes;
      case Constant.WorkspaceCategoryId.ApiAndIntegrationSupportId:
      case Constant.WorkspaceCategoryId.ApiAndIntegrationSupportOldId:
        return ApiAndIntegrationSupportProblemTypes;
      case Constant.WorkspaceCategoryId.DeveloperTools:
        return DeveloperToolsProblemTypes;
      case Constant.WorkspaceCategoryId.MicrosoftDynamics:
        return MicrosoftDynamicsProblemTypes;
      case Constant.WorkspaceCategoryId.ProductSupport:
        return ProductSupportProblemTypes;
      case Constant.WorkspaceCategoryId.VolumeLicensing:
        return VolumeLicensingProblemTypes;
      case Constant.WorkspaceCategoryId.EnrollmentId:
      case Constant.WorkspaceCategoryId.EnrollmentOldId:
        return EnrollmentProblemTypes;
      case Constant.WorkspaceId.AccountPlans:
        return AccountPlansProblemTypes;
      case Constant.WorkspaceId.Accounts:
        return AccountsProblemTypes;
      case Constant.WorkspaceId.Contacts:
        return ContactsProblemTypes;
      case Constant.WorkspaceId.Engagements:
        return EngagementsProblemTypes;
      case Constant.WorkspaceId.Leads:
        return LeadsProblemTypes;
      case Constant.WorkspaceId.Opportunities:
        return OpportunitiesProblemTypes;
      case Constant.WorkspaceId.Partners:
        return PartnersProblemTypes;
      case Constant.WorkspaceId.UserProvisioning:
        return UserProvisioningProblemTypes;
      case Constant.WorkspaceId.CALC:
        return CalcProblemTypes;
      case Constant.WorkspaceId.Compensation:
        return CompensationProblemTypes;
      case Constant.WorkspaceId.DealAssistance:
        return DealAssistanceProblemTypes;
      case Constant.WorkspaceId.Proposals:
        return ProposalsProblemTypes;
      case Constant.WorkspaceId.SalesAccelerator:
        return SalesAcceleratorProblemTypes;
      default:
        return AllProblemTypes;
    }
  };

  public static tupleComparator(a: number[], b: number[]) {
    if (a[1] < b[1]) return -1;
    if (a[1] > b[1]) return 1;
    return 0;
  }

  public static getTopTopicLabel = (supportTopic: SupportTopic) => {
    return (
      Helper.getProgramTagFromId((supportTopic && supportTopic.categories && supportTopic.categories[0]) ?? '') +
      ': ' +
      supportTopic.name
    );
  };

  public static topTopicDisplaySortHelper(
    supportTopicPairLeft: [SupportTopic, string],
    supportTopicPairRight: [SupportTopic, string]
  ) {
    let topicDisplayTextLeft = Helper.getTopTopicLabel(supportTopicPairLeft[0]);
    let topicDisplayTextRight = Helper.getTopTopicLabel(supportTopicPairRight[0]);
    if (topicDisplayTextLeft < topicDisplayTextRight) return -1;
    if (topicDisplayTextLeft > topicDisplayTextRight) return 1;
    return 0;
  }

  public static initializeFDstickyFooter = (retries = 3) => {
    if (retries >= 0) {
      try {
        (window as any).initializeStickyFooter();
      } catch {
        setTimeout(() => {
          Helper.initializeFDstickyFooter(retries - 1);
        }, 300);
      }
    }
  };

  public static getBrowserInfo = () => {
    var browserInfo: BrowserInfo = {
      userAgent: navigator.userAgent,
      browserVersion: navigator.appVersion,
    };
    return browserInfo;
  };

  public static isStringConvertableToInt = (number: string): boolean => {
    return !isNaN(Helper.convertStringToInt(number));
  };

  public static convertStringToInt = (number: string): number => {
    return parseInt(number, 10);
  };

  public static hasPunctuation = (value: string): boolean => {
    let punctuation = '/[.,/#!?$%^&*;:{}=-_`~()]/g';
    let regexp = new RegExp(punctuation);
    return value.match(regexp) === null;
  };

  public static getPunctuation = (): string => {
    return '.,/#!?$%^&*;:{}=-_`~()';
  };

  public static nameof = <T,>(name: keyof T) => name;

  public static displayTime(date: any, enableLocalTimeZone: boolean = false) {
    if (date) {
      return Helper.getFullLocalTime(new Date(date), sessionContext.Locale, enableLocalTimeZone);
    }

    return '';
  }

  public static getFullLocalTime(date: Date, locale: string, enableLocalTimeZone: boolean) {
    if (enableLocalTimeZone) {
      // Covert To Local Time Zone and format of String is also determined by Locale
      return date.toLocaleString(locale, { timeZoneName: 'short' });
    }
    // Time Zone is UTC but the string format is determined by Locale.
    return date.toLocaleString(locale, { timeZoneName: 'short', timeZone: 'UTC' });
  }

  public static displayLocalDate(date: string) {
    if (!Helper.isEmptyOrSpaces(date)) {
      let d = new Date(date);
      return d.toLocaleDateString(sessionContext.Locale);
    } else {
      return '';
    }
  }

  public static displayTimeSince(date: string) {
    if (date) {
      let givenDate = new Date(date);
      let current = new Date();

      let minutesSince = (new Date(current.toUTCString()).getTime() - givenDate.getTime()) / (1000 * 60);

      if (minutesSince < 1) {
        return 'Now';
      }

      //TODO: make resources for these strings
      if (minutesSince < 60) {
        const minutes = Math.floor(minutesSince).toString();
        const minuteString = minutes === '1' ? ' ' + MinuteAgoText : ' ' + MinutesAgoText;
        return minutes + minuteString;
      }
      let hoursSince = minutesSince / 60;
      if (hoursSince < 24) {
        const hours = Math.floor(hoursSince).toString();
        const hourString = hours === '1' ? ' ' + HourAgoText : ' ' + HoursAgoText;
        return hours + hourString;
      }

      let daysSince = hoursSince / 24;
      if (daysSince < 31) {
        const days = Math.floor(daysSince).toString();
        const dayString = days === '1' ? ' ' + DayAgoText : ' ' + DaysAgoText;
        return days + dayString;
      } else {
        return givenDate.toLocaleDateString(sessionContext.Locale);
      }
    } else {
      return '';
    }
  }

  //converts from utc to browser timezones
  public static getTimeInBrowserTimezone(dateTimeUTC: string) {
    let parsedDateUTC = new Date(dateTimeUTC);
    return this.convertDateToBrowserTimezone(parsedDateUTC);
  }

  //converts date from utc to browser timezone date
  public static convertDateToBrowserTimezone(dateTimeUTC: Date) {
    // offset is given as: offset = UTCTime - LocalTime
    // thus LocalTime = UTCTime - offset
    let timezoneOffsetInMinutes = dateTimeUTC.getTimezoneOffset();
    return new Date(dateTimeUTC.getTime() - timezoneOffsetInMinutes * 60000);
  }

  //converts from stringified date object in utc to local time in 12hr readable format
  public static convertDateTimeTolocaleShortTime(dateTimeUTC: string, removeLeadingZero: boolean = true) {
    let localDateTime = this.getTimeInBrowserTimezone(dateTimeUTC);
    let timeString = localDateTime.toLocaleTimeString(sessionContext.Locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    if (removeLeadingZero && timeString.length > 0 && timeString.charAt(0) === '0') {
      timeString = timeString.substring(1);
    }

    return timeString;
  }

  //converts from stringified date object in utc in 12hr readable format
  public static convertDateTimeToUTCShortTime(dateTimeUTC: string) {
    let utcDateTime = new Date(dateTimeUTC);
    return utcDateTime.toLocaleTimeString(sessionContext.Locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  }

  //returns whether a given date string occurred in the past
  public static isDateTimePast = (date: string): boolean => {
    let dateTimeInLocal = Helper.getTimeInBrowserTimezone(date);
    return dateTimeInLocal.getTime() < Date.now();
  };

  public static displayDate = (dateTime: string) => {
    const displayDateFormat: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return Helper.getTimeInBrowserTimezone(dateTime).toLocaleDateString(sessionContext.Locale, displayDateFormat);
  };

  public static ValidateTextBoxDefault(value: string): string {
    if (Helper.isEmptyOrSpaces(value)) {
      return '';
    }
    if (value.match(new RegExp(XssValidationRegex)) !== null) {
      return XssRegexErrorMessage_text;
    }
    return '';
  }

  public static ValidateTextBoxFullRegex(value: string): string {
    if (Helper.isEmptyOrSpaces(value)) {
      return '';
    }
    if (value.match(FullXssValidation) !== null) {
      return FullRegexErrorMessage_text;
    }
    return '';
  }

  public static getDateTimeInternationalFormat = (dateTime: Date): string => {
    let DateTimeOptions: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric', year: 'numeric' };
    return dateTime.toLocaleTimeString(sessionContext.Locale, DateTimeOptions);
  };

  public static trapFocus(
    element: { keyCode: any; which: any; shiftKey: any; preventDefault: () => void },
    firstItem: any,
    lastItem: any,
    altLastItem: any
  ) {
    var keyCode = element.keyCode || element.which;
    if (keyCode === 9) {
      if (element.shiftKey) {
        if ($(firstItem).is(':focus')) {
          if ($(lastItem).is(':disabled')) {
            $(altLastItem).focus();
          } else {
            $(lastItem).focus();
          }
          element.preventDefault();
        }
      } else {
        if ($(lastItem).is(':disabled')) {
          if ($(altLastItem).is(':focus')) {
            $(firstItem).focus();
            element.preventDefault();
          }
        } else if ($(lastItem).is(':focus')) {
          $(firstItem).focus();
          element.preventDefault();
        }
      }
    }
  }

  public static addScriptTag(scriptSrc: string, isDataEnabler: boolean = false) {
    var script = document.createElement('script');
    if (isDataEnabler) {
      script.setAttribute('data-enablers', scriptSrc);
    } else {
      script.src = scriptSrc;
      script.type = 'module';
    }
    script.defer = true;
    document.head.appendChild(script);
  }

  /**
   * Checks if the given url string is a valid url of type localhost, http, https, with or without wwww.
   * @param url
   */
  public static isValidURL(url: string): boolean {
    const regexp = /^(?:^|\s)((https?:\/\/)?(?:localhost|[\w-]+(?:\.[\w-]+)+)(:\d+)?(\/\S*)?)/;
    return regexp.test(url);
  }

  /**
   * Dedup an array absed on a given condition
   * @param array of any type
   * @param conditionToDedup whihc receives 2 objects from the array and returns a boolean if items should be deduped
   * @returns deduped array
   * */

  public static dedupArray(array: any[], conditionToDedup: Function): any[] {
    if (array == null || array.length < 1 || conditionToDedup == null) return array;
    return array.reverse().filter((v, i, a) => a.findIndex(v2 => conditionToDedup(v, v2)) === i);
  }

  /**
   * Logs a deep link event with its information
   * @param deepLinkInfo
   * @param tracingService
   */
  public static traceDeepLinkEvent = (deepLinkInfo: DeepLinkInfo, tracingService: TelemetryService) => {
    let action = {
      actionType: Constant.TraceTypes.TrackEvent,
      tags: Constant.actionTypes.createFlowDeepLinkSetFromUnAuth,
    };
    tracingService.traceEvent(
      Constant.actionTypes.createFlowDeepLinkSetFromUnAuth,
      {
        action: action,
        eventName: Constant.actionTypes.createFlowDeepLinkSetFromUnAuth,
        deepLinkInfo: deepLinkInfo,
      },
      EventGroupType.fullPage
    );
  };

  /**
   * Logs a deep link to AI Assistant event with its information
   * @param deepLinkInfo
   * @param tracingService
   */
  public static traceDeepLinkEventForAIAssistant = (deepLinkInfo: DeepLinkInfo, tracingService: TelemetryService) => {
    let action = {
      actionType: Constant.TraceTypes.TrackEvent,
      tags: Constant.actionTypes.openAIAssistantDeepLinkFromUnAuth,
    };
    tracingService.traceEvent(
      Constant.actionTypes.openAIAssistantDeepLinkFromUnAuth,
      {
        action: action,
        eventName: Constant.actionTypes.openAIAssistantDeepLinkFromUnAuth,
        deepLinkInfo: deepLinkInfo,
      },
      EventGroupType.fullPage
    );
  };

  /**
   * Saves a public support draft without waiting for authenticated session context.
   * The destination chooses the support experience after evaluating its flights.
   * @param topicId
   * @param targetState
   * @param verbatim
   * @param ticketTrackingId
   * @param browserStorage
   * @param tracingService
   */
  public static setPublicDeepLinkInfo = (
    topicId: string,
    targetState: SupportPanelState,
    verbatim: string,
    ticketTrackingId: string,
    browserStorage: BrowserStorage,
    tracingService: TelemetryService
  ) => {
    const deepLinkInfo: DeepLinkInfo = {
      targetState: targetState,
      topicId: topicId,
      verbatim: verbatim,
      ticketTrackingId: ticketTrackingId,
    };

    const saved = browserStorage.setItem(
      BrowserStorageKeys.publicDeepLinkInfo,
      deepLinkInfo,
      true,
      BrowserStorageType.temporary
    );
    if (!saved) {
      tracingService.traceError(new Error('Failed to save public support draft'));
      return;
    }
    Helper.traceDeepLinkEvent(deepLinkInfo, tracingService);
  };
}
